import axios from 'axios';

interface SolutionType {
  id?: number;
  specID: string;
  name: string;
  code: string;
}

class Solution implements SolutionType {
  id?: number;
  specID: string;
  name: string;
  code: string;

  constructor(solution: SolutionType) {
    this.id = solution.id;
    this.specID = solution.specID;
    this.name = solution.name;
    this.code = solution.code;
  }

  async create(): Promise<{message: string}> {
    const { data: response } = await axios.post('/admin/solutions', {
      specID: this.specID,
      name: this.name,
      code: this.code
    });

    if (response.error)
      throw new Error(response.error);

    return response as {message: string};
  }

  async destroy(): Promise<{message: string}> {
    if (!this.id) throw new Error('ID is required.');
    const { data } = await axios.delete('/admin/solutions', {
      data: {solutionID: this.id}
    });

    if (data.error)
      throw new Error(data.error);

    return data as {message: string};
  }

  static async find(query?: any): Promise<Solution[]> {
    const { data } = await axios.get('/admin/solutions', {params: query});

    return (data.solutions as SolutionType[]).map(a => new Solution(a));
  }
}

export default Solution;